import { Config } from 'core/common/contexts';
import { checkIsClientSide } from 'core/common/utils/checkIsClientSide';
import { normalizeURLPathname } from 'core/common/utils/normalizeURLPathname';
import { WebVitalsRecorder } from '../interfaces';
import { WebVitalsMetric } from './WebVitalsMetric';

export function createReportWebVitalsFn({
  config,
  recorder,
  pathname,
}: {
  config: Config['webVitals'];
  recorder: WebVitalsRecorder;
  pathname: string;
}) {
  const { trackedPages, trackedMetrics } = config;

  return (metric: WebVitalsMetric) => {
    if (!checkIsClientSide()) {
      return;
    }

    const normalizedPathname = normalizeURLPathname(pathname);

    if (
      !normalizedPathname ||
      !trackedPages.includes(normalizedPathname) ||
      !trackedMetrics.includes(metric.name)
    ) {
      return;
    }

    recorder.record({ metric, pathname: normalizedPathname });
  };
}
